import { SearchType } from '@search-bar/entities/search-type';

export function isByHours(type: SearchType): boolean {
  return type === SearchType.HOME_BYHOURS || 
         type === SearchType.BYHOURS_RESULTS || 
         type === SearchType.BYHOURS_DETAIL;
}
